import { PluginClient } from '@remixproject/plugin'
import { IRemixApi } from '@remixproject/plugin-api'
import { PluginApi } from '@remixproject/plugin-utils'

import Accordion from 'react-bootstrap/Accordion';
import Dropdown from 'react-bootstrap/Dropdown';

import Manual from "./Manual";
import Wallet from "./Wallet";

import { TESTNET_CHAIN_ID } from '../../utils/constants';
import { useEnvironmentStore } from '../../zustand/environmentStore'
import { useWeb3ModalAccount } from '@web3modal/ethers/react';

type EnvironmentProps = {
    client: PluginClient<any, Readonly<IRemixApi>> & PluginApi<Readonly<IRemixApi>>
}

const Environment = ({ client }: EnvironmentProps) => {
    const { chainId } = useWeb3ModalAccount()
    const { environment, updateEnvironment, updateRpcUrl } = useEnvironmentStore()

    const handleUpdate = (env: "Wallet" | "Manual" | "Remote Devnet", chainId: number | undefined) => {
        if (!chainId) {
            chainId = TESTNET_CHAIN_ID
        }

        updateEnvironment(env)
        updateRpcUrl(chainId)
    }

    return (
        <Accordion.Item eventKey='0' className='environment-accordion-item'>
            <Accordion.Header><b>Environment</b></Accordion.Header>
            <Accordion.Body>
                <p className="environment-header">Environment</p>
                
                <div className='environment-dropdown-container'>
                    <Dropdown>
                        <Dropdown.Toggle variant="secondary" size="sm">{environment}</Dropdown.Toggle>
                        <Dropdown.Menu>
                            { window.ethereum !== undefined ?<Dropdown.Item as="button" onClick={() => handleUpdate('Wallet', chainId)}>Wallet</Dropdown.Item> : <></> }
                            <Dropdown.Item as="button" onClick={() => handleUpdate('Manual', TESTNET_CHAIN_ID)}>Manual (Testnet)</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                
                    {environment === 'Wallet' && <Wallet client={client} />}
                </div>
                
                {environment === 'Manual' && <Manual client={client} />}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default Environment